import React from 'react'
import Faq from './Faq'
import Footer from './Footer'

export default function Our() {
  return (

    <div>
<div id="d31">
        <br/>
        <div class="container">
  <div class="row">
    <div class="col">
        <br/><br/>
     <p id="d41">Your order has been placed</p>
     <p id="d41">Our Team will contact you soon ...</p>
    <br/><br/>
    </div>
  </div>
</div> </div> 

<div>
 <br/><br/>   
    <Faq></Faq>
</div>

<br/><br/>

<div>
<Footer></Footer>
</div>      

    </div>
  )
}
